var map = {
	"./AP Biology.jpg": 917,
	"./AP Calculus AB.jpg": 7285,
	"./AP Calculus BC.jpg": 8157,
	"./AP Chemistry.jpg": 234,
	"./AP Physics 1.jpg": 5802,
	"./AP Physics 2-07.jpg": 1067,
	"./AP Physics C 02.jpg": 7080,
	"./AP Physics C.jpg": 9976,
	"./Abroad Exchange Program.jpg": 461,
	"./Abroad Masters Placement.jpg": 4284,
	"./Abroad Ph.D. Program.jpg": 6848,
	"./After School Prep Banner.jpg": 7352,
	"./After School Services.jpg": 3049,
	"./Ap.jpg": 3288,
	"./Career Counselling.jpg": 2512,
	"./Digital SAT.jpg": 275,
	"./Indian Entrance Prep.jpg": 293,
	"./Ivy-League.png": 8727,
	"./Ivy.jpg": 8721,
	"./K12.jpg": 1029,
	"./Macroeconomics.jpg": 5137,
	"./Medical.jpg": 3174,
	"./Medical.png": 2194,
	"./Microeconomics.jpg": 409,
	"./SAT.jpg": 3827,
	"./Us.png": 3211,
	"./australia-nz.png": 2944,
	"./canada.png": 7729,
	"./career.png": 5321,
	"./career1.png": 1524,
	"./course.svg": 2540,
	"./ind.png": 3956,
	"./india.svg": 8976,
	"./medical-hero.png": 3773,
	"./sat-test-1.JPG": 4803,
	"./sat-test-2.JPG": 3172,
	"./uk.png": 1651,
	"./uk.svg": 8255,
	"./usa-admission.png": 3297,
	"./usa-admission1.png": 7970,
	"./usa.png": 2842,
	"./usa1.png": 8057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3358;